// extracted by css-extract-rspack-plugin
export default {"Title":"LogVolunteeringActivity_Title__vr0xk","Description":"LogVolunteeringActivity_Description__2bNGU"};